export const DURATION_TRIAL_TIME_ROOT_SX = { display: 'flex' };

export const DURATION_TRIAL_TIME_VALUE_SX = {
  fontWeight: 700,
  textAlign: 'right',
  width: 24,
};

export const DURATION_TRIAL_TIME_UNIT_SX = {
  fontSize: 12,
  fontWeight: 700,
  mt: 0.2,
};

export const DURATION_TRIAL_TIME_SEPARATOR_SX = { mx: 0.5 };
